var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DefaultCard',{staticClass:"z-20 select-none"},[_c('Heading',{staticClass:"mb-16",attrs:{"center":""}},[_vm._v("Payment Options")]),_c('DefaultPaymentSource')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }